import classNames from 'classnames';
import { Children, cloneElement, type FC, type HTMLAttributes, type ReactElement } from 'react';

import { TCell, type TCellProps } from '../tcell';
import styles from './trow-fillable.module.scss';

type TCellElement = ReactElement<TCellProps, typeof TCell>;

export type TRowFillableProps = HTMLAttributes<HTMLTableRowElement> & {
  children: TCellElement | TCellElement[];
  hasHover?: boolean;
  className?: string;
  fillPercent?: number;
};

export const TRowFillable: FC<TRowFillableProps> = ({
  children,
  className,
  hasHover,
  fillPercent,
  onClick,
  ...props
}) => (
  <tr
    className={classNames(styles.root, className, {
      [styles.hasOnClick]: !!onClick,
      [styles.hover]: hasHover,
    })}
    onClick={onClick}
    {...props}
    style={{
      ...(fillPercent !== undefined ? { ['--fill-percent' as any]: `${fillPercent}%` } : {}),
      ...props.style,
    }}
  >
    {Children.map(children, (child, index) => cloneElement(child, { index }))}
  </tr>
);
